<script setup>
const props = defineProps({
  list: {
    type: Array,
    default() {
      return [];
    },
  },
  modelValue: {
    type: [String, Number, Array],
    default() {
      return '';
    },
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <UiSelect
    :list="list"
    :model-value="modelValue"
    class="ui-select-group"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template v-slot:options>
      <ElOptionGroup
        v-for="group in list"
        :key="group.label"
        :label="group.label"
      >
        <ElOption
          v-for="item in group.options"
          :key="item.id"
          :label="item.text"
          :value="item.id"
        />
      </ElOptionGroup>
    </template>
  </UiSelect>
</template>

<style lang="scss">
.ui-select-group {
  .el-select-group__title {
    color: #303634;
    font-size: 13px;
    font-weight: 700;
    padding: 0 6px;
  }
}
</style>